module.exports = __webpack_public_path__ + "images/emoji/arrow_up_down.5d5d9ee60a09c1258ac5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_up_down.png
// module id = 5fgv
// module chunks = 14